export default {
    inputRoot: {
        '&.MuiOutlinedInput-root': {
            padding: '0px 9px !important',
        },
    },
};
  